<div class="sat-card" [class.sat-card--expanded]="expanded">
  <div class="sat-card-header" [style.background]="headerBackgroundColor" (click)="onToggle()">
    <div class="sat-card-header__start">
      <span class="sat-chevron">{{ expanded ? '▼' : '▶' }}</span>
      <span class="sat-dot" [style.background-color]="accentColor"></span>
      <span class="sat-category-name" [style.color]="accentColor">{{ category.name }}</span>
      <span class="sat-category-meta" *ngIf="expanded">{{ attributeTypeCountLabel }}</span>
      <span class="sat-category-meta" *ngIf="!expanded">{{ category.collapsedSummary }}</span>
    </div>
    <div class="sat-card-header__actions" (click)="$event.stopPropagation()">
      <button type="button" class="sat-btn sat-btn--outline sat-btn--sm" (click)="onAddType($event)">
        + Add Type
      </button>
      <button type="button" class="sat-btn sat-btn--muted sat-btn--sm sat-btn--with-icon" (click)="onEditCategory($event)">
        <mat-icon>edit</mat-icon>
        Edit Category
      </button>
    </div>
  </div>

  <div class="sat-card-body" *ngIf="expanded">
    <ng-container *ngIf="category.attributeTypes.length; else emptyCategory">
      <app-store-attribute-type-row
        *ngFor="let attributeType of category.attributeTypes"
        [attributeType]="attributeType"
        [categoryName]="category.name"
        [categoryColor]="category.color"
        [filterToggleSaving]="filterToggleSavingId === attributeType.id"
        (manageValues)="manageValues.emit($event)"
        (deleteType)="deleteType.emit($event)"
        (filterEnabledChange)="filterEnabledChange.emit($event)">
      </app-store-attribute-type-row>
    </ng-container>

    <ng-template #emptyCategory>
      <p class="sat-empty-category">No attribute types in this category yet.</p>
    </ng-template>
  </div>
</div>
